import { withAsyncLoading } from '../../../Components/Templates/Loading/AsyncPageLoading/withAsyncPageLoading';

const LoadableControleDetailsPage = withAsyncLoading(async () =>
    import('./ControleDetailsPage').then((res) => res.ControleDetailsPage)
);

export { LoadableControleDetailsPage };
